{
  "code": "Code o le valaaulia",
  "error": {
    "details": "<ul>  \n<li>Siaki mo ni sipelaga sese ona toe taumafai lea.</li>  \n<li>Afai o lo’o e manaʻomia se fesoasoani, vala’au mai i le {{phone}} (ona oomi lea o le Filifiliga 2).</li>  \n</ul>",
    "title": "E le aoga le code o le valaaulia"
  },
  "helpMessage": "<p>Ua leiloa lau valaaulia pe e te le mautinoa le mea e fai?<br />Fa‘amolemole vala‘au mai i le <a><strong>{{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>).</p>",
  "text": "<p>Ulufale lau code valaaulia e 6 mata‘itusi e amata ai.</p><p>O le a e mauaina lenei code i lau valaaulia i le imeli, po’o le tagata na fa‘asino mai oe na tu‘uina atu.</p>",
  "title": "Ulufale i lau valaaulia mo le tusi taimi"
}
